import theme from '../../base';

const price = {
  foregroundSecondInfo: theme.colors.neutrals.gray300,
  foregroundGrayscaledInfo: theme.colors.neutrals.gray300,
  foregroundPrimaryInfo: theme.colors.blues.blue200,
};

export default price;
